import HttpClient from "../base/http-client";

export default class CategoryClient extends HttpClient {
  constructor() {
    super("category", true);
  }
}
